import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Cookies from 'js-cookie';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
import '@/styles/heyui.less';
import '@/styles/index.less';
import '@/styles/common.less';
import 'animate.css';
import VueTianditu from 'vue-tianditu'
// 插件
import '@/plugins/ui';
import '@/plugins/heyui';
import dispatchEventStroage from '@/utils/index'

Vue.use(dispatchEventStroage)

import {
  swiper,
  swiperSlide,
} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

Vue.component('Swiper', swiper);
Vue.component('SwiperSlide', swiperSlide);
Vue.use(Element, {
  size: Cookies.get('size') || 'medium',
});
Element.Dialog.props.closeOnClickModal.default = false;

// 引入vue-tianditu
Vue.use(VueTianditu, {
  v: '4.0',
  /**
   * 正式：17332123d6fe8db7a69439eb065ab50b
   * 测试：3e639c78db69e0fdbf23abc0fcf6ce23
   */
  tk: '9b5e942edc0cc85e1a22aea8ce050a78', // 正式17332123d6fe8db7a69439eb065ab50b
  plugins: ['']
})

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');